import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor,HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../services';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError(this.handleError)
        );
    }
    handleError(error: any) {

        // client-side error
        if (error.error instanceof ErrorEvent) {
            // display error message
            //this._snackBar.open(error.message, "Error");
        }
        // server-side error
        else {
            if (error.status === 500) {
                //  redirect to error page 
               // this._router.navigate(['/server-error']);
               console.log(1,error);
            } else {
                // display error message
                //this._snackBar.open(error.message, "Error");
                console.log(2,error);
            }
        }
        return throwError(error.message);
    }
}